// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-container {
  display: flex;
  margin: 0 300px;
  height: 66.6vh;
}
.request-container .sign-in-login, .request-container .listing-detail {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: center;
  height: 500px;
}
.request-container .listing-detail {
  align-self: center;
}
.request-container .sign-in-login {
  align-items: center;
  height: 600px;
}
.request-container .sign-in-login .header, .request-container .sign-in-login .subheader {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  text-align: center;
  margin: 0;
}
.request-container .sign-in-login .header {
  font-size: 50px;
  color: var(--secondary-color-1);
}
.request-container .sign-in-login .subheader {
  font-size: 20px;
  line-height: 40px;
  color: var(--secondary-color-3);
}
.request-container .sign-in-login .button-container {
  display: flex;
  flex-direction: column;
  width: 450px;
  position: relative;
}
.request-container .sign-in-login .button-container p.or {
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  text-align: center;
  color: var(--secondary-color-2);
}
.request-container .sign-in-login .button-container p.or:before, .request-container .sign-in-login .button-container p.or:after {
  content: "";
  width: 200px;
  height: 1px;
  position: absolute;
  margin-top: 11.5px;
}
.request-container .sign-in-login .button-container p.or:before {
  margin-right: 10px;
  background-color: var(--secondary-color-2);
  opacity: 0.3;
  left: 0;
}
.request-container .sign-in-login .button-container p.or:after {
  margin-left: 10px;
  background-color: var(--secondary-color-2);
  opacity: 0.3;
  right: 0;
}
.request-container .listing-detail {
  align-items: flex-end;
}
.request-container .listing-detail .detail-container {
  display: flex;
  flex-direction: column;
  width: 450px;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
}
.request-container .listing-detail .detail-container .address, .request-container .listing-detail .detail-container .listing {
  font-size: 20px;
  font-weight: 700;
  color: var(--secondary-color-3);
  margin: 0;
}
.request-container .listing-detail .detail-container .listing {
  color: var(--secondary-color-2);
}
.request-container .listing-detail .detail-container .preview {
  width: 450px;
  height: 250px;
  object-fit: cover;
  border-radius: 10px;
}
.request-container .listing-detail .badge {
  height: 40px;
  width: 150px;
  background: rgba(250, 201, 31, 0.2);
  display: flex;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
}
.request-container .listing-detail .badge > span {
  color: var(--primary-color-1);
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 700;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .request-container {
    height: 100%;
    flex-direction: column;
    margin: 0 40px;
  }
  .request-container .sign-in-login .header {
    font-size: 40px;
  }
  .request-container .sign-in-login .subheader {
    font-size: 18px;
    line-height: 35px;
  }
  .request-container .sign-in-login .button-container {
    width: 100%;
  }
  .request-container .sign-in-login .button-container p.or:before, .request-container .sign-in-login .button-container p.or:after {
    width: 120px;
  }
  .request-container .listing-detail {
    align-items: flex-end;
  }
  .request-container .listing-detail .detail-container {
    width: 100%;
  }
  .request-container .listing-detail .detail-container .address, .request-container .listing-detail .detail-container .listing {
    font-size: 18px;
  }
  .request-container .listing-detail .detail-container .preview {
    width: 100%;
  }
  .request-container .listing-detail .badge {
    height: 40px;
    width: 150px;
    background: rgba(250, 201, 31, 0.2);
    display: flex;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
  }
  .request-container .listing-detail .badge > span {
    color: var(--primary-color-1);
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 700;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/modules/LoginToRequest/loginToRequest.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,eAAA;EACA,cAAA;AADJ;AAEI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;AAAR;AAEI;EAAkB,kBAAA;AACtB;AAAI;EACI,mBAAA;EACA,aAAA;AAER;AADQ;EACI,uCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AAGZ;AADQ;EACI,eAAA;EACA,+BAAA;AAGZ;AADQ;EACI,eAAA;EACA,iBAAA;EACA,+BAAA;AAGZ;AADQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAGZ;AAFY;EACI,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;AAIhB;AAFgB;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAIpB;AAFgB;EACI,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,OAAA;AAIpB;AAFgB;EACI,iBAAA;EACA,0CAAA;EACA,YAAA;EACA,QAAA;AAIpB;AACI;EACI,qBAAA;AACR;AAAQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,uCAAA;AAEZ;AADY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AAGhB;AADY;EAAW,+BAAA;AAIvB;AAHY;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AAKhB;AAFQ;EACI,YAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAIZ;AAHY;EACI,6BAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AAKhB;;ACrGY;EDwGR;IACI,YAAA;IACA,sBAAA;IACA,cAAA;EACN;EACU;IACI,eAAA;EACd;EACU;IACI,eAAA;IACA,iBAAA;EACd;EACU;IACI,WAAA;EACd;EACkB;IACI,YAAA;EACtB;EAIM;IACI,qBAAA;EAFV;EAGU;IACI,WAAA;EADd;EAEc;IACI,eAAA;EAAlB;EAEc;IACI,WAAA;EAAlB;EAGU;IACI,YAAA;IACA,YAAA;IACA,mCAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,uBAAA;EADd;EAEc;IACI,6BAAA;IACA,iCAAA;IACA,eAAA;IACA,gBAAA;EAAlB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.request-container {\n    display: flex;\n    margin: 0 300px;\n    height: 66.6vh;\n    .sign-in-login, .listing-detail {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        justify-content: center;\n        height: 500px;\n    }\n    .listing-detail { align-self: center; }\n    .sign-in-login {\n        align-items: center;\n        height: 600px;\n        .header, .subheader {\n            font-family: 'Proxima Nova', sans-serif;\n            font-weight: 700;\n            text-align: center;\n            margin: 0;\n        }\n        .header {\n            font-size: 50px;\n            color: var(--secondary-color-1);\n        }\n        .subheader {\n            font-size: 20px;\n            line-height: 40px;\n            color: var(--secondary-color-3);\n        }\n        .button-container {\n            display: flex;\n            flex-direction: column;\n            width: 450px;\n            position: relative;\n            p.or {\n                font-family: \"Roboto\", sans-serif;\n                font-size: 20px;\n                text-align: center;\n                color: var(--secondary-color-2);\n    \n                &:before, &:after{\n                    content: \"\";\n                    width: 200px;\n                    height: 1px;\n                    position: absolute;\n                    margin-top: 11.5px;\n                }\n                &:before {\n                    margin-right: 10px;\n                    background-color: var(--secondary-color-2);\n                    opacity: .3;\n                    left: 0;\n                }\n                &:after {\n                    margin-left: 10px;\n                    background-color: var(--secondary-color-2);\n                    opacity: .3;\n                    right: 0;\n            }\n            }\n        }\n    }\n    .listing-detail {\n        align-items: flex-end;\n        .detail-container {\n            display: flex;\n            flex-direction: column;\n            width: 450px;\n            align-items: center;\n            font-family: 'Proxima Nova', sans-serif;\n            .address, .listing {\n                font-size: 20px;\n                font-weight: 700;\n                color: var(--secondary-color-3);\n                margin: 0;\n            }\n            .listing { color: var(--secondary-color-2); }\n            .preview {\n                width: 450px;\n                height: 250px;\n                object-fit: cover;\n                border-radius: 10px;\n            }\n        }\n        .badge {\n            height: 40px;\n            width: 150px;\n            background: rgba(#FAC91F, .2);\n            display: flex;\n            border-radius: 5px;\n            align-items: center;\n            justify-content: center;\n            > span {\n                color: var(--primary-color-1);\n                font-family: \"Roboto\", sans-serif;\n                font-size: 14px;\n                font-weight: 700;\n            }\n        }\n          \n    }\n}\n\n@include media(mobile) {\n    .request-container {\n        height: 100%;\n        flex-direction: column;\n        margin: 0 40px;\n        .sign-in-login {\n            .header {\n                font-size: 40px;\n            }\n            .subheader {\n                font-size: 18px;\n                line-height: 35px;\n            }\n            .button-container {\n                width: 100%;\n                p.or {        \n                    &:before, &:after{\n                        width: 120px;\n                    }\n                }\n            }\n        }\n        .listing-detail {\n            align-items: flex-end;\n            .detail-container {\n                width: 100%;\n                .address, .listing {\n                    font-size: 18px;\n                }\n                .preview {\n                    width: 100%;\n                }\n            }\n            .badge {\n                height: 40px;\n                width: 150px;\n                background: rgba(#FAC91F, .2);\n                display: flex;\n                border-radius: 5px;\n                align-items: center;\n                justify-content: center;\n                > span {\n                    color: var(--primary-color-1);\n                    font-family: \"Roboto\", sans-serif;\n                    font-size: 14px;\n                    font-weight: 700;\n                }\n            }\n              \n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
